import { h } from '@atomify/jsx';
import { Button, ButtonInterface } from '@atoms/button/button';
import { Image, ImageInterface } from '@atoms/image';

export interface NotificationCardInterface {
    variant?: string;
    extraClass?: string;
    title?: string | Text;
    image?: ImageInterface;
    contentLink?: ButtonInterface;
    children?: Element[];
}

export const NotificationCard = (data: NotificationCardInterface): Element => {
    const elementClasses = {
        ['c-notification-card']: true,
        ...(data.variant && { [`notification-card--${data.variant}`]: true }),
        ...(data.extraClass && { [data.extraClass]: true }),
    };

    data.contentLink = {
        ...data.contentLink,
        classes: `notification-card__button ${data.contentLink?.classes || ''}`.trim(),
    };

    return (
        <div class={elementClasses}>
            {data.image ? (
                <Image
                    {...data.image}
                    classes="notification-card__image"
                    preload={{ width: 16, height: 9 }}
                    settings={{
                        '320w': { width: 320, height: 140 },
                        '640w': { width: 640, height: 360 },
                        '1024w': { width: 512, height: 288 },
                        '1440w': { width: 720, height: 405 },
                        '1920w': { width: 960, height: 540 },
                    }}
                    objectFit
                />
            ) : null}

            <div class="notification-card__content">
                {data.title ? <p class="u-h5 notification-card__title">{data.title}</p> : null}

                {data.children ? <div class="s-rich-text">{data.children}</div> : null}

                {data.contentLink ? (
                    <Button variant="primary" width="full-width" {...data.contentLink} />
                ) : null}
            </div>
        </div>
    );
};
